import { render, staticRenderFns } from "./warnDataModal.vue?vue&type=template&id=fa22ba46&scoped=true&"
import script from "./warnDataModal.vue?vue&type=script&lang=js&"
export * from "./warnDataModal.vue?vue&type=script&lang=js&"
import style0 from "./warnDataModal.vue?vue&type=style&index=0&id=fa22ba46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa22ba46",
  null
  
)

export default component.exports